import { createContext } from "react";

// TEXT

// STYLES

// DATA

// TYPES
export type Props = {
  children: React.ReactNode;
  mode?: ThemeMode;
};

export type ThemeContextType = {
  theme: ThemeMode;
  toggleTheme: () => void;
};

type ThemeMode = "dark" | "light" | "system";

// CONSTANTS
const defaultThemeState: ThemeContextType = {
  theme: "dark",
  toggleTheme: () => {
    throw new Error("useTheme must be used within a ThemeProvider");
  },
};

export const ThemeContext = createContext<ThemeContextType>(defaultThemeState);

// FUNCTIONS

// ASSETS
